<script>
export default {
  props: {
    faultMessages: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Fault Messages',
    },
    onOpenRawReport: {
      type: Function,
      default: () => {},
    },
    onVisualize: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
